<ai-dismissible-info-banner
  storageKey="ai-assistant-tool-info-closed"
  icon="bolt"
  [title]="'AI_ASSISTANT.FUNCTIONS.TOOL_INFO.TITLE' | translate"
>
  <div [innerHTML]="'AI_ASSISTANT.FUNCTIONS.TOOL_INFO.CONTENT' | translate"></div>
</ai-dismissible-info-banner>

<form [formGroup]="form()" class="tool-form">
  <glxy-form-field bottomSpacing="small" [required]="true">
    <glxy-label>{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.NAME' | translate }}</glxy-label>
    <input type="text" matInput formControlName="id" />
    @if (form().controls.id.errors && form().controls.id.touched) {
      <glxy-error>{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.NAME_PATTERN_ERROR' | translate }}</glxy-error>
    } @else {
      <glxy-hint>{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.NAME_HELP_TEXT' | translate }}</glxy-hint>
    }
  </glxy-form-field>
  <glxy-form-field [required]="true">
    <glxy-label>{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.DESCRIPTION' | translate }}</glxy-label>
    <input type="text" matInput formControlName="description" />
    <glxy-hint>{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.DESCRIPTION_HELP_TEXT' | translate }}</glxy-hint>
  </glxy-form-field>
  <glxy-form-field>
    <mat-checkbox [formControl]="form().controls.noOp">{{
      'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.NO_OP_DESCRIPTION' | translate
    }}</mat-checkbox>
  </glxy-form-field>

  @if (!form().controls.noOp.value) {
    <div class="button-container">
      <button mat-stroked-button (click)="openCurlImportDialog()" [disabled]="form().disabled">
        <mat-icon class="import-icon">code</mat-icon>
        {{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.GENERATE_FROM_CURL' | translate }}
      </button>
      <button mat-stroked-button (click)="copyCurlCommand()">
        <mat-icon class="copy-icon">content_copy</mat-icon>
        {{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.EXPORT_TO_CURL' | translate }}
      </button>
    </div>
  }

  @if (!form().controls.generatesAnswer.value && !form().controls.noOp.value) {
    <glxy-form-row>
      <glxy-form-field class="col-xs-12 col-sm-3" bottomSpacing="small">
        <glxy-label
          >{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.METHOD' | translate }}
          <mat-icon
            class="info-icon"
            [glxyTooltip]="'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.METHOD_TOOLTIP_TEXT' | translate"
          >
            info_outline
          </mat-icon>
        </glxy-label>
        <mat-select formControlName="method">
          @for (option of httpMethods; track option) {
            <mat-option [value]="option">{{ option }}</mat-option>
          }
        </mat-select>
        <glxy-hint>{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.METHOD_HELP_TEXT' | translate }}</glxy-hint>
      </glxy-form-field>
      <glxy-form-field class="col-xs-12 col-sm-9" bottomSpacing="small" [required]="true">
        <glxy-label>{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.URL' | translate }}</glxy-label>
        <input
          type="text"
          matInput
          formControlName="url"
          placeholder="{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.URL_PLACEHOLDER' | translate }}"
        />
        @let urlErrors = form().controls.url.errors;
        @if (urlErrors && urlErrors['invalidHttpUrl']) {
          <glxy-error>{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.URL_ERROR' | translate }}</glxy-error>
        } @else {
          <glxy-hint>{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.URL_HINT' | translate }}</glxy-hint>
        }
      </glxy-form-field>
    </glxy-form-row>

    <div class="headers">
      <div class="parameters-header">
        {{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.HEADERS' | translate }}
        <mat-icon
          class="info-icon"
          [glxyTooltip]="'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.HEADERS_HELP_TEXT' | translate"
        >
          info_outline
        </mat-icon>
      </div>
      <ai-tool-header-form-array
        [forms]="form().controls.headers"
        class="header-forms-array"
      ></ai-tool-header-form-array>
    </div>
  }
  <div class="parameters-header">
    {{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.PARAMETERS' | translate }}
    <mat-icon
      class="info-icon"
      [glxyTooltip]="'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.PARAMETERS_HELP_TEXT' | translate"
    >
      info_outline
    </mat-icon>
  </div>
  <ai-tool-parameter-form-array [forms]="form().controls.parameters"></ai-tool-parameter-form-array>

  @if (showConstraints()) {
    <ai-constraints-field
      [constraintsForm]="form().controls.constraints"
      class="constraints-form"
    ></ai-constraints-field>
  }
</form>
